import _ from 'underscore';
import $ from 'jquery';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import BulkUnlinkLightbox from './bulk-unlink-lightbox';
import instrument from '@bingads-webui-static-legacy/instrumentation/index';
import instrumentConsts from '@bingads-webui-static-legacy/instrumentation/constants';
import { getCCUrl } from '@bingads-webui-component-legacy/bingads-grid/shared/clientcenter-url-helper';

const i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/bulk-unlink-accounts');

const unlinkaccountsUrl = 'managers/bulkunlinkaccounts';
const unlinkaccountsUrlConfirmation = 'managers/bulkunlinkaccountsconfirmation';
const { HierarchyAccountTypeValue } = Constants;

export default function bulkUnlinkAccounts({selectedAccounts, customerId, userId, onConfirm}) {
  const bulkUnlinkModel = {
    accounts: _.map(selectedAccounts, (account) => {
      return {
        number: account.AccountNumber,
        name: account.Name,
        type: HierarchyAccountTypeValue[account.AccountType] || HierarchyAccountTypeValue.Unknown,
        id: account.Id,
        managers: _.map(account.ManagerAccounts, (manager) => {
          return {
            name: manager.Name,
            number: manager.CustomerNumber,
            id: manager.Id,
          };
        }),
      };
    }),
  };
  const unlinkConfirmationUrl = getCCUrl(unlinkaccountsUrlConfirmation);

  $.advertiser.ajaxPost({
    url: unlinkConfirmationUrl,
    xhrFields: {
      withCredentials: true,
    },
    data: {cid: customerId, uid: userId, unlinkacc: JSON.stringify(bulkUnlinkModel)},
    onSuccess: (model) => {
      if (model && model.accounts) {
        const dialogView = new BulkUnlinkLightbox({
          accountsCount: model.accounts.length,
          buttonEvent: () => {
            const revisedModel = {accounts: model.accounts, returnUrl: window.location.href };
            const redirectUri = getCCUrl(unlinkaccountsUrl, { cid: customerId, uid: userId });

            onConfirm(revisedModel, redirectUri);
          },
        });

        dialogView.render();
      } else {
        $.advertiser.appendErrorSummary(i18n.getString('GenericErrorMessage_Short'));
        instrument.logMessage(instrumentConsts.LOGCATEGORY.ERROR, instrumentConsts.LOGLEVEL.INFO, 'bulkunlinkaccounts empty model', JSON.stringify(bulkUnlinkModel));
      }
    },
    onError: (e) => {
      $.advertiser.appendErrorSummary(i18n.getString('GenericErrorMessage_Short'));
      instrument.logMessage(instrumentConsts.LOGCATEGORY.ERROR, instrumentConsts.LOGLEVEL.INFO, `bulkunlinkaccounts/ajaxPost failed with ${JSON.stringify(e)}`, JSON.stringify(bulkUnlinkModel));
    },
    hideLoadingPanelOnSuccess: true,
  });
}
